import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Layout from "@/_LayoutsRelated/layout/Layout";
import { unbxdAnalytics } from "@/redux/actions/unbxdActions";
import { serverUrl } from "@globalConfig";
import PostViewMain from "@/pages/post/PostViewMain";
import useApi from "@hooks/useApi";
import Loader from "@componentsShared/Loader/Loader";
import { useFullPageData } from "@/common/Contexts/FullPageContext";
import { api__getNewPostViewData } from "@/apis/posts/getNewPostViewData";
import useFullLoading from "@hooks/useFullLoading";
import { usePostDetails } from "@/common/Contexts/PostDetailsContext";
import { extractPostId } from "./helpers/postHelpers";
function PostViewPage() {
  var _postDetails$details, _postDetails$details2, _postDetails$details3, _location$state;
  var location = useLocation();
  var postId = extractPostId(location.pathname);
  var _usePostDetails = usePostDetails(),
    setPostDetails = _usePostDetails.setPostDetails;
  var searchParams = new URLSearchParams(location.search);
  var showExcludedDealers = searchParams.get('test') === '1' ? 1 : 0;
  var postViewApiResponseFullPageData = useFullPageData();
  var _useApi = useApi([postId], function () {
      return api__getNewPostViewData(postId, null, [], 1, showExcludedDealers);
    }, null, postViewApiResponseFullPageData === null || postViewApiResponseFullPageData === void 0 ? void 0 : postViewApiResponseFullPageData.postDetails),
    _useApi2 = _slicedToArray(_useApi, 3),
    loading = _useApi2[0],
    error = _useApi2[1],
    postDetails = _useApi2[2];
  var fullPageLoading = useFullLoading();
  var metaTags = postDetails === null || postDetails === void 0 ? void 0 : postDetails.meta;
  var switchLink = postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$details = postDetails.details) === null || _postDetails$details === void 0 ? void 0 : _postDetails$details.product_url_alt;
  useEffect(function () {
    var params = {
      action: "product_view",
      url: serverUrl + location.pathname + location.search,
      pid: postId
    };
    unbxdAnalytics(params);
  }, []);
  useEffect(function () {
    document.title = "".concat(metaTags !== null && metaTags !== void 0 && metaTags.title ? metaTags === null || metaTags === void 0 ? void 0 : metaTags.title : "");
  }, [metaTags === null || metaTags === void 0 ? void 0 : metaTags.title]);
  useEffect(function () {
    setPostDetails(postDetails);
    return function () {
      setPostDetails(null);
    };
  }, [postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$details2 = postDetails.details) === null || _postDetails$details2 === void 0 ? void 0 : _postDetails$details2.id]);
  return /*#__PURE__*/React.createElement(Layout, {
    mobileHasBack: true,
    hideDownloadBanner: true,
    switchLink: switchLink,
    linksForSearch: true,
    mainClass: ["PBT", (postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$details3 = postDetails.details) === null || _postDetails$details3 === void 0 ? void 0 : _postDetails$details3.limited_quantity) && "limitedAvaPBT"].join(" "),
    disableLoader: true,
    hideOrangeHeadBtn: true
  }, (fullPageLoading || loading) && /*#__PURE__*/React.createElement(Loader, null), !loading && /*#__PURE__*/React.createElement(PostViewMain, {
    financeView: true,
    loading: loading,
    screen_view_referral: location === null || location === void 0 ? void 0 : (_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.screen_view_referral
  }));
}
export default PostViewPage;